export const ADD_LIST_REQUEST = 'ADD_LIST_REQUEST';
export const LIST_CUSTOM_IMAGE = 'LIST_CUSTOM_IMAGE';
export const LIST_COLOR = 'LIST_COLOR';
export const LIST_LIBRARY_IMAGE = 'LIST_LIBRARY_IMAGE';
export const LIST = 'LIST';
